import Ajv from 'ajv'
import addErrors from 'ajv-errors'
import addFormats from 'ajv-formats'

const ajv = new Ajv({
  allErrors: true,
  strict: false,
  $data: true,
})

addErrors(ajv)
addFormats(ajv)

export default ajv
